import { toast } from "react-toastify";

const handelLead = async (user_id, bot_id, name, email, phone_no) => {
  let visitor_id = localStorage.getItem("visitor_id");

  try {
    const uri = `${process.env.REACT_APP_SERVER}/other/newlead`;
    const body = {
      user_id: user_id,
      bot_id: bot_id,
      name: name || null,
      email: email || null,
      phone_no: phone_no || null,
      visitor_id: visitor_id,
    };

    const option = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    const res = await fetch(uri, option);
    if (res.status === 200) {
      toast.success("Lead submitted! We'll follow up shortly.");
      localStorage.setItem("lead_user", JSON.stringify(body));
      return;
    } else {
      return;
    }
  } catch (err) {
    console.log(err);
    return;
  }
};

export default handelLead;
